export const SVELTE_INFINITEGRID_PROPS = [
  "status",
  "useFirstRender",
  "useLoading",
  "usePlaceholder",
  "items",
  "itemBy",
  "groupBy",
];
